import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  NEW: "bg-blue-50 text-blue-700 border-blue-200",
  REQUEST: "bg-blue-50 text-blue-700 border-blue-200",
  ASSIGNED: "bg-blue-50 text-blue-700 border-blue-200",
  OFFERS: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  CLIENT_DECISION: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  READY_TO_BOOK: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  TRIAGE: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  SOURCING: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  AWAITING_SUPPLIER: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  AWAITING_CLIENT: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  COMPLETED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  CANCELLED: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  CONFIRMED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  AMENDED: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  PARTIALLY_CANCELLED: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  DRAFT: "bg-gray-100 text-gray-600 border-gray-200",
  SENT: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  QUEUED: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  ISSUED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  REVIEWED: "bg-blue-50 text-blue-700 border-blue-200",
  SENDING: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  UNKNOWN: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  DEAD: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  FAILED: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  EXPORTED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  BLOCKED_SETUP: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  PENDING: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  ACCEPTED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  DECLINED: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  SUPERSEDED: "bg-gray-100 text-gray-600 border-gray-200",
  SUBMITTED: "bg-blue-50 text-blue-700 border-blue-200",
  LOW: "bg-gray-100 text-gray-600 border-gray-200",
  MEDIUM: "bg-blue-50 text-blue-700 border-blue-200",
  HIGH: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  CRITICAL: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  VALID: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  EXPIRING: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  MISSING: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  EXPIRED: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  APPLIED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  APPROVED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  INFO_REQUESTED: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  REJECTED: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  RECORDED: "bg-blue-50 text-blue-700 border-blue-200",
  RECONCILED: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  NOT_CONNECTED: "bg-gray-100 text-gray-600 border-gray-200",
  DRY_RUN: "bg-blue-50 text-blue-700 border-blue-200",
  PAUSED: "bg-gray-100 text-gray-600 border-gray-200",
  ACTIVE: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  URGENT: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  TO_QUOTE: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  CURRENT: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  UPCOMING: "bg-blue-50 text-blue-700 border-blue-200",
  PAST: "bg-gray-100 text-gray-600 border-gray-200",
  NO_STAY: "bg-gray-100 text-gray-600 border-gray-200",
  ON_TRACK: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  DUE_SOON: "bg-jigsaw-warningBg text-jigsaw-warning border-jigsaw-warning/30",
  OVERDUE: "bg-jigsaw-dangerBg text-jigsaw-danger border-jigsaw-danger/30",
  MET: "bg-jigsaw-successBg text-jigsaw-success border-jigsaw-success/30",
  NOT_CONFIGURED: "bg-gray-100 text-gray-600 border-gray-200",
};

// Display labels only - the enum value stays in data-testid and in every API/URL.
const STATUS_LABELS = {
  REQUEST: "Open", ASSIGNED: "Assigned", SOURCING: "In progress", OFFERS: "Offers received", CLIENT_DECISION: "Awaiting your input",
  READY_TO_BOOK: "Ready to book", COMPLETED: "Completed", CANCELLED: "Cancelled", CONFIRMED: "Confirmed", PARTIALLY_CANCELLED: "Partially cancelled",
  NOT_CONNECTED: "Not connected", BLOCKED_SETUP: "Blocked - setup", DRY_RUN: "Dry-run", PAUSED: "Paused", ACTIVE: "Active",
  CURRENT: "Currently accommodated", UPCOMING: "Upcoming stay", PAST: "Past guest", NO_STAY: "No stay recorded", TO_QUOTE: "To quote", ON_TRACK: "On track", DUE_SOON: "Due soon", OVERDUE: "Overdue", MET: "Met", NOT_CONFIGURED: "Not configured", LOW: "Low", MEDIUM: "Medium", HIGH: "High", CRITICAL: "Critical", URGENT: "Urgent",
};

export const statusLabel = (status) => STATUS_LABELS[status] || String(status).replace(/_/g, " ");

export function StatusBadge({ status, className }) {
  const style = STATUS_STYLES[status] || "bg-gray-100 text-gray-600 border-gray-200";
  return (
    <span
      data-testid={`status-badge-${String(status).toLowerCase()}`}
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[12px] font-medium before:h-1.5 before:w-1.5 before:rounded-full before:bg-current before:opacity-70",
        style,
        className
      )}
    >
      {STATUS_LABELS[status] || String(status).replace(/_/g, " ")}
    </span>
  );
}
